import React, {Component, PropTypes} from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import {
  Col,
  Button,
  FormGroup,
  InputGroup,
  DropdownButton,
  MenuItem, ControlLabel, Form, FormControl
} from '@sketchpixy/rubix';
import {
  charge,
  updateOpportunityLink,
  getPaymentDetail,
  updateBillingDate
} from '../../../api/api';
import NumberFormat from "react-number-format";
import moment from "moment";
import ContractStatus from "../../../constants/ContractStatus";
import {StyledFormGroup} from "../../payment/FromStyle";
import InputValidationType from "../../../constants/InputValidationType";


const Root = styled(Col)`
  padding: 0;
`;


const Container = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: ${props => props.expand ? '2px' : '1px'} solid #d8d8d8;

`;

const Title = styled.div`
  height: 65px;
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
  font-size: 18px;
`;

const Item = styled.div`
  display: flex;
  min-height: 60px;
  text-align: justify;
   
  &:last-child {
    border-bottom: 0;
  }
  
  & div:first-child {
    color: black;
  }
  
  & div {
    margin-top: auto;
    margin-bottom: auto;
    padding: 0;
  }
`;

const ItemTitle = styled.div`
  width: 202px;
  font-size: 16px;
`;

class Charge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payment: null,
      amount: {
        formattedValue: '',
        value: null,
      },
    };
  }

  componentDidMount() {
    this.getPaymentDetail();
  }

  displayAmount = (amount) => {
    const scientificNotation = Math.pow(10, this.props.decimalScale * -1);
    return (amount * scientificNotation).toFixed(2);
  };

  charge = () => {
    let amount = this.state.amount.value
    if(amount == null || amount == 0)
    {
      vex.dialog.alert('Please input amount!');
      return
    }
    let taxRate = this.state.payment.taxRate;

    let taxAmount        = parseInt(amount * taxRate);
    let totalAmount      = amount + taxAmount;

    let self = this;

    vex.dialog.confirm({
      message: 'Are you sure to charge $' + this.displayAmount(totalAmount) + '(tax : ' + this.displayAmount(taxAmount) + ', amount : ' + this.displayAmount(amount) + ')?',
      callback: function (value) {
        if (value) {
          charge(self.state.amount.value, self.props.contract.contractId, (err, res) => {
            if (err) {
              vex.dialog.alert('Failed to charge!');
            } else if (res.statusCode != '0') {
              let message = res.statusMessage == '' ? 'Failed to charge!' : res.statusMessage;
              vex.dialog.alert(message);
            } else {
              vex.dialog.alert('Charged!');
              self.props.charged()
            }
          });
        } else {
          console.log('Charge canceled')
        }
      }
    });
  };

  getPaymentDetail() {
    getPaymentDetail(this.props.contract.contractId, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        const payment = result.detail;
        this.setState({
          payment
        });

      }
    });
  }

  amountChangeHandler = (values) => {
    let amount = this.state.amount;

    const {formattedValue, value} = values;

    amount.formattedValue = formattedValue;
    amount.value = value * 100;

    this.setState({
      amount
    });
  };


  render() {
    const amount = this.state.amount;

    let numberInputFormatProps = {
      className: 'form-control',
      thousandSeparator: true,
      decimalScale: 2,
      fixedDecimalScale: true,
      allowNegative: false,
    };

    return (
        <Root xs={12}>
          <Title>Charge <span style={{ paddingLeft: "20px", color: 'red' }}>* It wil be paid right away with customer's card, so you should be used with caution</span></Title>
          <Container>
              <Item>
                <ItemTitle>Amount</ItemTitle>
                  <FormGroup>
                    <InputGroup>
                      <InputGroup.Addon>{this.props.contract.currencyString}</InputGroup.Addon>
                      <NumberFormat
                          {...numberInputFormatProps}
                          value={amount.formattedValue}
                          onValueChange={(values) => this.amountChangeHandler(values)}
                      />
                      <InputGroup.Button>
                        <Button bsStyle='red' onClick={this.charge}>Charge</Button>
                      </InputGroup.Button>
                    </InputGroup>
                  </FormGroup>
              </Item>
          </Container>
        </Root>
    );
  }
}

Charge.propTypes = {
  charged: PropTypes.func.isRequired,
  contract: PropTypes.shape({
    contractId: PropTypes.number,
    currencyName: PropTypes.string,
    currencyCode: PropTypes.string,
    currencyString: PropTypes.string,
    contractSalesRepEmail: PropTypes.string,
    contractPatientEmail: PropTypes.string,
    contractPgType: PropTypes.string,
    contractPgBillingKey: PropTypes.string,
    contractDevicesDetail: PropTypes.string,
    contractBillingDate: PropTypes.number,
    nextPaymentDate: PropTypes.string,
    contractStatus: PropTypes.string,
    installmentPeriod: PropTypes.number,
    contractOnetimeAmount: PropTypes.number,
    contractHardwareAmount: PropTypes.number,
    contractPostalCode: PropTypes.string,
    contractTaxRate: PropTypes.number,
    patientSubscription: PropTypes.object,
    payments: PropTypes.array,
    schedule: PropTypes.object,
    opportunityLink: PropTypes.string,
    createdTime: PropTypes.number,
    updatedTime: PropTypes.number,
  }).isRequired,
};


export default Charge;



// WEBPACK FOOTER //
// ./src/routes/patient/PaymentInfo/Charge.js